import firebase from "firebase";

const config = {
  apiKey: "AIzaSyAxOKnY6_6Iqby_deINaP_BumZjhS9FmPM",
  authDomain: "tdcurve.firebaseapp.com",
  databaseURL: "https://tdcurve.firebaseio.com",
  projectId: "tdcurve",
  storageBucket: "tdcurve.appspot.com",
  messagingSenderId: "259331619203",
};
firebase.initializeApp(config);
export const provider = new firebase.auth.GoogleAuthProvider();
export const auth = firebase.auth();
export default firebase;
